module.exports = __webpack_public_path__ + "img/qiche.622d0c0e.png";